import { useState } from 'react';
import { mutate } from 'swr';
import { AccountList } from '@/components/account/AccountList';
import { AccountSheet } from '@/components/account/AccountSheet';
import { CreateAccountModal, EditAccountModal } from '@/components/account';
import type { Account } from '@/types/account';

export function AccountPage() {

  // Sheet state
  const [selectedAccountToken, setSelectedAccountToken] = useState<string | null>(null);
  const [isSheetOpen, setIsSheetOpen] = useState(false);

  // Modal state
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [editAccountToken, setEditAccountToken] = useState<string>('');

  const handleView = (account: Account) => {
    setSelectedAccountToken(account.accountToken);
    setIsSheetOpen(true);
  };

  const handleEdit = (account: Account) => {
    setEditAccountToken(account.accountToken);
    setIsEditOpen(true);
  };

  const handleEditFromSheet = (account: Account) => {
    setIsSheetOpen(false);
    setEditAccountToken(account.accountToken);
    setIsEditOpen(true);
  };

  const handleCreate = () => {
    setIsCreateOpen(true);
  };

  const handleSuccess = () => {
    mutate('accounts');
  };

  const handleSheetOpenChange = (open: boolean) => {
    setIsSheetOpen(open);
    if (!open) {
      setSelectedAccountToken(null);
    }
  };

  return (
    <>
      <div className="mb-6">
        <h1 className="text-3xl font-bold tracking-tight">Accounts</h1>
        <p className="mt-1 text-muted-foreground">
          Manage the tenant accounts that scope feedback collection
        </p>
      </div>

      <AccountList
        onView={handleView}
        onEdit={handleEdit}
        onCreate={handleCreate}
      />

      <AccountSheet
        open={isSheetOpen}
        accountToken={selectedAccountToken}
        onOpenChange={handleSheetOpenChange}
        onEdit={handleEditFromSheet}
      />

      <CreateAccountModal
        isOpen={isCreateOpen}
        onClose={() => setIsCreateOpen(false)}
        onSuccess={handleSuccess}
      />

      {editAccountToken && (
        <EditAccountModal
          isOpen={isEditOpen}
          accountToken={editAccountToken}
          onClose={() => setIsEditOpen(false)}
          onSuccess={handleSuccess}
        />
      )}
    </>
  );
}
